
import React, {
  useState,
  useEffect,
  useCallback,
} from "react";


import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import "./Testimonials.css";


const testimonials = [
  {
    id: "01",
    quote:
      "ETOE Productions created beautiful cinematic visuals that brought our brand communication to life. The creative camera work and storytelling gave our project a professional and memorable feel.",
    name: "Aarika Real Estate Team",
    role: "Client",
    company: "AARIKA REAL ESTATE",

    // Professional female portrait
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=500&q=90",

    // Project image
    projectImage:
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1600&q=90",
  },

  {
    id: "02",
    quote:
      "The team understood our vision perfectly. The expressive cinematography, thoughtful framing and smooth sequences created a video that felt creative, professional and engaging.",
    name: "Jasmine Team",
    role: "Client",
    company: "JASMINE",

    // Professional female portrait
    image:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=500&q=90",

    // Project image
    projectImage:
      "https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=1600&q=90",
  },

  {
    id: "03",
    quote:
      "ETOE delivered high-quality visual content that represented our brand professionally. The dynamic cinematography and strong storytelling made the final production stand out.",
    name: "1011 Properties Team",
    role: "Client",
    company: "1011 PROPERTIES",

    // Professional male portrait
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=500&q=90",

    // Project image
    projectImage:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=90",
  },

  {
    id: "04",
    quote:
      "ETOE turned our story into a fresh and engaging visual experience. The natural visuals, creative compositions and smooth storytelling made the final video truly memorable.",
    name: "The Fresh Story Team",
    role: "Client",
    company: "THE FRESH STORY",

    // Professional female portrait
    image:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=500&q=90",

    // Project image
    projectImage:
      "https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=1600&q=90",
  },

  {
    id: "05",
    quote:
      "ETOE Productions created a professional corporate film that presented our brand with strong visuals and clear storytelling. The final production gave our brand a powerful visual presence.",
    name: "KEZAD Group Team",
    role: "Client",
    company: "KEZAD GROUP",

    // Professional male portrait
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=500&q=90",

    // Project image
    projectImage:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1600&q=90",
  },

  {
    id: "06",
    quote:
      "ETOE captured the excitement and atmosphere of the rally beautifully. The energetic cinematography and immersive storytelling brought the entire event to life.",
    name: "Kandura Rally Team",
    role: "Client",
    company: "KANDURA RALLY",

    // Professional male portrait
    image:
      "https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?auto=format&fit=crop&w=500&q=90",

    // Automotive / rally project image
    projectImage:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=1600&q=90",
  },

  {
    id: "07",
    quote:
      "The team captured the spirit and style of our event with beautiful cinematic storytelling. The refined visuals made every memorable moment feel special.",
    name: "Abaya Rally Team",
    role: "Client",
    company: "ABAYA RALLY",

    // Professional female portrait
    image:
      "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?auto=format&fit=crop&w=500&q=90",

    // Fashion / lifestyle project image
    projectImage:
      "https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=1600&q=90",
  },

  {
    id: "08",
    quote:
      "The ETOE production showcased our creative identity through cinematic storytelling, dynamic camera movements and polished post-production. It perfectly reflected our approach to filmmaking.",
    name: "ETOE Productions",
    role: "Production House",
    company: "ETOE PRODUCTIONS",

    // Professional male portrait
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=500&q=90",

    // Film / cinema project image
    projectImage:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1600&q=90",
  },

  {
    id: "09",
    quote:
      "ETOE captured the energy and excitement of the automotive event through dynamic visuals and cinematic storytelling. The final production created a strong and engaging event experience.",
    name: "Calling All Cars Team",
    role: "Event Client",
    company: "CALLING ALL CARS",

    // Professional male portrait
    image:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=500&q=90",

    // Automotive project image
    projectImage:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=1600&q=90",
  },

  {
    id: "10",
    quote:
      "The production beautifully captured confidence, meaningful connections and inspiring moments. ETOE created a cinematic story that felt emotional, authentic and memorable.",
    name: "A Story of Confidence Team",
    role: "Event Client",
    company: "A STORY OF CONFIDENCE",

    // Professional female portrait
    image:
      "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=500&q=90",

    // Event / people project image
    projectImage:
      "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=1600&q=90",
  },

  {
    id: "11",
    quote:
      "ETOE captured the energy, atmosphere and visual character of Dubai through a strong cinematic approach. The final production turned the event into an engaging visual story.",
    name: "Dubai Really Showed Up Team",
    role: "Event Client",
    company: "DUBAI REALLY SHOWED UP",

    // Professional male portrait
    image:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=500&q=90",

    // Dubai project image
    projectImage:
      "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1600&q=90",
  },
];




function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState("next");
  const [isChanging, setIsChanging] = useState(false);

 

  const getRelativePosition = useCallback(
    (index) => {
      let difference = index - activeIndex;

      const half = testimonials.length / 2;

      if (difference > half) {
        difference -= testimonials.length;
      }

      if (difference < -half) {
        difference += testimonials.length;
      }

      return difference;
    },
    [activeIndex]
  );

  const changeTestimonial = useCallback(
    (nextIndex, newDirection = "next") => {
      if (
        isChanging ||
        nextIndex === activeIndex
      ) {
        return;
      }

      setDirection(newDirection);
      setIsChanging(true);

      window.setTimeout(() => {
        setActiveIndex(nextIndex);

        window.setTimeout(() => {
          setIsChanging(false);
        }, 80);
      }, 260);
    },
    [activeIndex, isChanging]
  );

  const handleNext = useCallback(() => {
    const nextIndex =
      (activeIndex + 1) % testimonials.length;

    changeTestimonial(nextIndex, "next");
  }, [activeIndex, changeTestimonial]);

  const handlePrevious = useCallback(() => {
    const previousIndex =
      (
        activeIndex -
        1 +
        testimonials.length
      ) % testimonials.length;

    changeTestimonial(
      previousIndex,
      "previous"
    );
  }, [activeIndex, changeTestimonial]);

  useEffect(() => {
    const handleKeyboard = (event) => {
      if (event.key === "ArrowRight") {
        handleNext();
      }

      if (event.key === "ArrowLeft") {
        handlePrevious();
      }
    };

    window.addEventListener(
      "keydown",
      handleKeyboard
    );

    return () => {
      window.removeEventListener(
        "keydown",
        handleKeyboard
      );
    };
  }, [handleNext, handlePrevious]);

  return (
    <section
      className="testimonials"
      id="testimonials"
    >
      <div className="testimonials-container">
        <header className="testimonials-header">
 

          <h2 className="testimonials-heading">
            TRUST BUILT
            <span>THROUGH THE WORK</span>
          </h2>

          <p className="testimonials-description">
            Every project is built on trust, teamwork, and a commitment to delivering results that exceed expectations
          </p>
        </header>

     

        <div
          className={`testimonials-carousel testimonials-direction-${direction} ${
            isChanging
              ? "testimonials-carousel-changing"
              : ""
          }`}
        >
          <div className="testimonials-carousel-glow" />

          <div className="testimonials-track">
            {testimonials.map((testimonial, index) => {
              const position =
                getRelativePosition(index);

              return (
                <article
                  key={testimonial.id}
                  className={`testimonial-card ${
                    position === 0
                      ? "testimonial-card-active"
                      : ""
                  }`}
                  style={{
                    "--testimonial-position": position,
                    "--testimonial-distance":
                      Math.abs(position),
                  }}
                  onClick={() => {
                    if (position === 0) {
                      return;
                    }

                    changeTestimonial(
                      index,
                      position > 0
                        ? "next"
                        : "previous"
                    );
                  }}
                >
                  <img
                    className="testimonial-card-image"
                    src={testimonial.projectImage}
                    alt=""
                  />

                  <div className="testimonial-card-overlay" />

                  <div className="testimonial-card-top">
                    <span>
                      ETOE / CLIENT STORY
                    </span>

                    <span>{testimonial.id}</span>
                  </div>

                  <div className="testimonial-card-content">
                    <span className="testimonial-card-company">
                      {testimonial.company}
                    </span>

                    <blockquote>
                      {testimonial.quote}
                    </blockquote>

                    <div className="testimonial-card-author">
                      <div className="testimonial-card-avatar">
                        <img
                          src={testimonial.image}
                          alt={testimonial.name}
                        />
                      </div>

                      <div>
                        <h3>
                          {testimonial.name}
                        </h3>

                        <p>
                          {testimonial.role}
                        </p>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>


<div className="testimonial-navigation">

    <button
        className="testimonial-arrow"
        onClick={handlePrevious}
        aria-label="Previous"
    >
        <FiArrowLeft />
    </button>

    <div className="testimonial-center">
        <div className="testimonial-dots">
            {testimonials.map((_, index) => (
                <button
                    key={index}
                    type="button"
                    className={`testimonial-dot ${
                        activeIndex === index ? "active" : ""
                    }`}
                    onClick={() => setActiveIndex(index)}
                    aria-label={`Go to testimonial ${index + 1}`}
                />
            ))}
        </div>
    </div>

    <button
        className="testimonial-arrow"
        onClick={handleNext}
        aria-label="Next"
    >
        <FiArrowRight />
    </button>

</div>
      </div>

      <div className="testimonials-background-glow" />
    </section>
  );
}

export default Testimonials;